/**
 * Extracts the domain from a URL string, removing the protocol and 'www.' prefix.
 *
 * @param url - The URL string to extract the domain from
 * @returns The domain without protocol or 'www.' prefix, or empty string if invalid
 *
 * @example
 * getDomainFromUrl('https://www.example.com/path') // 'example.com'
 * getDomainFromUrl('example.com') // 'example.com'
 * getDomainFromUrl('') // ''
 */
export const getDomainFromUrl = (url: string): string => {
  if (!url || typeof url !== 'string') {
    return ''
  }

  const trimmedUrl = url.trim()
  if (!trimmedUrl) {
    return ''
  }

  try {
    // Add protocol if missing so URL constructor can parse it
    const urlWithProtocol = trimmedUrl.startsWith('http')
      ? trimmedUrl
      : `https://${trimmedUrl}`

    const urlObj = new URL(urlWithProtocol)
    return urlObj.hostname.replace(/^www\./, '')
  } catch {
    return ''
  }
}
